/**
 * @generated SignedSource<<76d0c1250f590b526612e341fb256ace>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ContactInfoState = "DRAFT" | "VERIFIED";
export type ContactInfoType = "EMAIL" | "PHONE";
export type ContactInfoFieldVerifyMutation$variables = {
  code: string;
  type: ContactInfoType;
};
export type ContactInfoFieldVerifyMutation$data = {
  readonly verifyContactInfo: {
    readonly contactInfo?: {
      readonly id: string;
      readonly state: ContactInfoState;
      readonly type: ContactInfoType;
      readonly value: string;
    };
    readonly me?: {
      readonly email: string;
      readonly id: string;
      readonly phone: string;
    };
    readonly message?: string;
  };
};
export type ContactInfoFieldVerifyMutation = {
  response: ContactInfoFieldVerifyMutation$data;
  variables: ContactInfoFieldVerifyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "code"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v2 = [
  {
    "kind": "Variable",
    "name": "code",
    "variableName": "code"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContactInfo",
      "kind": "LinkedField",
      "name": "contactInfo",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Me",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phone",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContactInfoMutationResult",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "ContactInfoVerifyError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactInfoFieldVerifyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "verifyContactInfo",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContactInfoFieldVerifyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "verifyContactInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "123ea4acce8db6cbfb7241949d730e38",
    "id": null,
    "metadata": {},
    "name": "ContactInfoFieldVerifyMutation",
    "operationKind": "mutation",
    "text": "mutation ContactInfoFieldVerifyMutation(\n  $type: ContactInfoType!\n  $code: String!\n) {\n  verifyContactInfo(type: $type, code: $code) {\n    __typename\n    ... on ContactInfoMutationResult {\n      contactInfo {\n        id\n        type\n        value\n        state\n      }\n      me {\n        id\n        email\n        phone\n      }\n    }\n    ... on ContactInfoVerifyError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5bb3fff9ba06147e154c18bcf1b5bdff";

export default node;
